import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig";
import AOPPrev from "./AOPPrev";
import { AOPSwitzerlandStudentData } from "@/src/types/admissionOffice";

const emptyStudentState = (): AOPSwitzerlandStudentData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  passportNumber: "",
  academicYear: "",
  duration: "",
  mediumOfInstruction: "",
  yearOfStudy: "",
  yearStudyMode: "",
  coursePrefix: "",
  bodyStudentLetter: [],
  file: null,
  signature: "Juliet Derchi",
});

const AOPStudentLetterSwissLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPSwitzerlandStudentData>(emptyStudentState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPSwitzerlandStudentData>(emptyStudentState);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
      />
      <AOPPrev bodyForPrev={bodyForPrev} />
    </div>
  );
};

export default AOPStudentLetterSwissLayout;
